import { useState, useRef } from "react";
import { useSelector } from "react-redux";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { TaskPreview } from "../task/task-preview";
import { updateGroupAction, updatePickerCmpsOrder, addActivity, setDynamicModalObj } from "../../store/board.actions";
import { setDynamicModalObj2 } from "../../store/grupo.actions";
import { saveNewTask, updateGrupoAction,updateActivityOrder } from "../../store/grupo.actions";
import { updateSubActivityOrder } from "../../store/grupo.actions"
import { boardService } from "../../services/board.service";
import { TaskToolsModal } from "../modal/task-tools-modal";
import { StatisticGroup } from "./statistics-group";
import { useNavigate } from 'react-router-dom';
import { BsFillCircleFill } from 'react-icons/bs';
import { BiChevronDown, BiChevronRight, BiDotsHorizontalRounded } from 'react-icons/bi';
import { AiOutlinePlus} from 'react-icons/ai';
//para el manejo de alertas
import 'react-toastify/dist/ReactToastify.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,Tooltip } from '@mui/material';
import { grupoService } from '../../services/grupo.service';
import ProgressBar from '../modal/modal-fechaporse'; // Asegúrate de que la ruta sea correcta
import EstadoModal from '../modal/modal-statusP'; // Asegúrate de que la ruta sea correcta
import{ROLES,userService}from '../../services/user.service'



export function GroupPreview({ group, board, users, idx, customHeight}) {
    const [showGroup, setShowGroup] = useState(false);
    const [taskToEdit, setTaskToEdit] = useState(boardService.getEmptyTask());
    const [isTyping, setIsTyping] = useState(false);
    const [isShowColorPicker, setIsShowColorPicker] = useState(false);
    const [selectedTasks, setSelectedTasks] = useState([]);
    const [isMainCheckbox, setIsMainCheckbox] = useState({ isActive: false });
    const navigate = useNavigate();

    const idGrupo = group.id_grupo;
    const [width, setWidth] = useState('500px');
    const [width2, setWidth2] = useState('200px');

    //para el menu resumen
    const dynamicModalObj2 = useSelector(storeState => storeState.grupoModule.dynamicModalObj);
    const dynamicModalObj = useSelector(storeState => storeState.boardModule.dynamicModalObj)
    const [isHovered, setIsHovered] = useState(false);
    //fin del resumen
    // const user = useSelector(storeState => storeState.userModule.user);
    const [user, setUser] = useState(userService.getLoggedinUser().data.data); //Usuario logueado en la interfaz

    const guest = "https://res.cloudinary.com/du63kkxhl/image/upload/v1675013009/guest_f8d60j.png";
    const elMainGroup = useRef();
    const elAddColumn = useRef();
    const isEditable = user.rol === ROLES.ADMIN;
    const grupos = useSelector(state => state.grupoModule.grupos); //para el orden de las actividades

    function loadColumns() {
        const columns = board.cmpsOption.filter(cmpOption => !board.cmpsOrder.includes(cmpOption));
        return columns;
    }


    function onToggleMenuModal() {
     
        const isOpen = dynamicModalObj2?.group.id_grupo === group.id_grupo && dynamicModalObj2?.type === 'menu-group' ? !dynamicModalObj2.isOpen : true;
        const { x, y, height, width } = elMainGroup.current.getClientRects()[0];
        setDynamicModalObj2({ isOpen, pos: { x: 125, y: (y + height) }, type: 'menu-group', group: group });
    }

    function onTogglePalette() {
        const isOpen = dynamicModalObj2?.group.id_grupo === group.id_grupo && dynamicModalObj2?.type === 'menu-group' ? !dynamicModalObj2.isOpen : true;
        const { y, height } = elMainGroup.current.getClientRects()[0];
        setDynamicModalObj2({ isOpen, pos: { x: 125, y: (y + height) }, type: 'menu-group', group: group });
    }

  
    
    

    function toggleColumnModal() {
        const columns = loadColumns();
        const isOpen = dynamicModalObj?.group.id_grupo === group.id_grupo && dynamicModalObj?.type === 'add-column' ? !dynamicModalObj.isOpen : true;
        const { x, y, height } = elAddColumn.current.getClientRects()[0];
        setDynamicModalObj({ isOpen, pos: { x: (x - 225), y: (y + height) }, type: 'add-column', group, columns });
    }

    // async function onSave(ev) { //investigar posible funcion para actualizar el grupo
    //     const value = ev.target.innerText;
    //     group.title = value;
    //     try {
    //         await updateGroupAction(board, group);
    //         setIsTyping(false);
    //         setIsShowColorPicker(false);
    //     } catch (err) {
    //         console.log('Failed to save');
    //     }
    // }


    async function onSave(ev) {
        ev.preventDefault();
        
        // Extraer los valores del grupo que se quieren actualizar
        const updatedGroup = {
            id_grupo: group.id_grupo,
            nombre_grupo: ev.target.innerText, // Suponiendo que se está editando el nombre del grupo
            estado: group.estado,
            fk_tableros_id: group.fk_tableros_id,
            color: group.color
        };
    
        try {
            await updateGrupoAction(updatedGroup.id_grupo, updatedGroup);
            setIsTyping(false);
            setIsShowColorPicker(false);
        } catch (err) {
            console.log('Failed to save');
        }
    }


    
    function handleChange({ target }) {
        const { name, value } = target;
        setTaskToEdit(prevTask => ({ ...prevTask, [name]: value }));
    }


    function onAddTask(ev) {
        ev.preventDefault();
    
        if (!taskToEdit.descripcion) return;
    
        const newTask = {
            ...taskToEdit,
            fk_estado_id: 1,
            fk_grupo_id: group.id_grupo,
            fk_proyecto_id: null,
            meta:null,
            ejecucion: null,
            medio_verificacion: null,
            avances: null,
            fecha_inicio: null,
            fecha_final: null,
            archivada: 0,
            id_carpeta_drive: null,
            linea_presupuestaria: null,
            monto: 0
        };
        
        saveNewTask(newTask, group.id_grupo)
            .then((savedTask) => {
                setTaskToEdit(boardService.getEmptyTask());
                
                // Aquí puedes actualizar el estado con la tarea guardada que incluye el id_actividad
                // También puedes actualizar el grupo correspondiente en tu estado global si es necesario
            })
            .catch((err) => {
                console.error('Error al guardar la tarea:', err);
            });
    }


    function handleHorizontalDrag(ev) {
        const updatedTitles = [...board.cmpsOrder];
        const [draggedItem] = updatedTitles.splice(ev.source.index, 1);
        updatedTitles.splice(ev.destination.index, 0, draggedItem);
        updatePickerCmpsOrder(board, updatedTitles);
    }

    async function handleCheckboxChange(task) {
        try {
            if (selectedTasks.includes(task)) {
                selectedTasks.splice(selectedTasks.indexOf(task), 1);
                setSelectedTasks((selectedTasks) => ([...selectedTasks]));
                addCheckActivity(true, task);
            } else {
                addCheckActivity(false, task);
                setSelectedTasks((prevTasks) => ([...prevTasks, task]));
            }
        } catch (err) {
            console.log('err:', err);
        }
    }

    function onClickMainCheckbox() {
        if (isMainCheckbox.isActive) setSelectedTasks([]);
        else setSelectedTasks(group.tasks);
        setIsMainCheckbox({ isActive: !isMainCheckbox.isActive });
    }

    //opcion 2
    function addCheckActivity(isCheckBoxDown, task) {
        const activity = boardService.getEmptyActivity();
        activity.task = { id: task.id, title: task.title };
        activity.action = 'check';
        activity.from = isCheckBoxDown;
        activity.to = !isCheckBoxDown;
        // addActivity(board, activity);
    }

    function getSumOfTasks() {
        try {
            const sum = group.actividades.length;
            let subItems = 0;
    
            // Asegúrate de que `actividades` y `subactividades` sean arrays válidos
            subItems = group.actividades.reduce((acc, task) => 
                acc + (task.subactividades && Array.isArray(task.subactividades) ? task.subactividades.length : 0)
            , 0);
    
            // Calcula las horas totales
            const totalHoras = sumHorasTrabajo(group.actividades);
    
            if (sum > 1) 
                return `${sum} elementos / ${subItems} tareas / ${totalHoras} horas`;
            else if (sum === 1) 
                return `1 item / ${subItems} tareas / ${totalHoras} horas`;
            else 
                return 'Sin Elementos';
        } catch (error) {
            console.error('Error en getSumOfTasks:', error);
            return 'Sin Elementos';
        }
    }
    
    const sumHorasTrabajo = (actividades) => {
        try {
            // Asegúrate de que `actividades` sea un array válido
            return actividades.reduce((total, task) => {
                // Asegúrate de que `subactividades` sea un array válido
                const subTotal = (task.subactividades && Array.isArray(task.subactividades))
                    ? task.subactividades.reduce((subTotal, subactividad) => 
                        subTotal + (typeof subactividad.horas_trabajo === 'number' ? subactividad.horas_trabajo : 0)
                    , 0)
                    : 0;
                return total + subTotal;
            }, 0);
        } catch (error) {
            console.error('Error en sumHorasTrabajo:', error);
            return 0;
        }
    };
    


    const [fechas, setFechas] = useState(null);

    // Función para obtener las fechas desde la API
    function fetchDates(idGrupo) {
        grupoService.getMinMaxDates(idGrupo)
            .then(result => {
                setFechas(result);
            })
            .catch(error => {
                console.error('Error fetching dates:', error);
            });
    }


    function getAddColumnClassName() {
        return dynamicModalObj.isOpen === true && dynamicModalObj.type === 'add-column' && dynamicModalObj?.group.id_grupo === group.id_grupo;
    }






// FUNCIÓN PARA ACTUALIZAR EL ORDEN DE LAS ACTIVIDADES
const handleDragEnd = async (result) => {
    if (!result.destination) {
        return; // Si no hay destino, no hacer nada
    }

    const { source, destination } = result;

    // Si la posición no ha cambiado, no hacer nada
    if (
        destination.droppableId === source.droppableId &&
        destination.index === source.index
    ) {
        return;
    }

    const groupId = parseInt(source.droppableId.split('-')[1], 10); // Identificar el grupo

    const sourceGroup = grupos.find(grupo => grupo.id_grupo === groupId);
    if (!sourceGroup) {
        console.error("Grupo no encontrado.");
        return;
    }

    // Trabajamos directamente con las actividades, sin clonarlas
    const actividades = sourceGroup.actividades;

    // Aseguramos que las actividades estén ordenadas por posicion_elemento
    actividades.sort((a, b) => a.posicion_elemento - b.posicion_elemento);

    // Mover la actividad a la nueva posición
    const [actividadMovida] = actividades.splice(source.index, 1);
    actividades.splice(destination.index, 0, actividadMovida);

    // Actualizar la posición de cada actividad
    actividades.forEach((actividad, index) => {
        actividad.posicion_elemento = index; // Asignar nueva posición
    });

    // Hacer el dispatch para actualizar el orden sin necesidad de clonar los grupos
    console.log("Grupos antes de actualizar:", grupos);
    updateActivityOrder(groupId, grupos);
};



// Asegúrate de que esta función esté definida en el mismo componente o sea pasada como prop
const handleDragEndTask = async (result) => {
    const { source, destination } = result;

    if (!destination || (destination.droppableId === source.droppableId && destination.index === source.index)) {
        return; // No hacer nada si no hay destino o no hay cambio de posición
    }

    const actividadId = Number(source.droppableId.split('-')[1]); 

    // Verificar si grupos es un arreglo y encontrar la actividad por actividadId
    const actividad = grupos?.flatMap(grupo => grupo.actividades)?.find(({ id_actividad }) => id_actividad === actividadId);
    if (!actividad) {
        console.error("Actividad no encontrada o grupos no es un arreglo válido.");
        return;
    }

    // Trabajamos directamente con las subactividades
    const subactividades = actividad.subactividades;


    // Mover el elemento dentro del array de subactividades original
    const [subactividadMovida] = subactividades.splice(source.index, 1);
    subactividades.splice(destination.index, 0, subactividadMovida);

    // Actualizar la posición de cada subactividad
    subactividades.forEach((subactividad, index) => {
        subactividad.posicion_elemento = index;
    });


    // Llamar a la función de actualización
    updateSubActivityOrder(actividadId, subactividades, actividad.fk_grupo_id);
};




const handleDragProcess = async (result) => {
    const { source, destination, type } = result;

    if (!destination) {
        return; // Si no hay destino, no hacer nada
    }

    if (
        destination.droppableId === source.droppableId &&
        destination.index === source.index
    ) {
        return; // Si la posición no ha cambiado, no hacer nada
    }

    if (type === 'PARENT') {
        await handleDragEnd(result);
        console.log(result);
    } else if (type === 'TASK') {
        await handleDragEndTask(result);
        console.log(result);
    } else {
        console.error("Tipo de drag no reconocido:", type);
    }

}

// const handleDragProcess = async (result) => {
//     switch (result.type) {
//         case 'PARENT':
//             handleDragEnd(result);
//             break;
//         case 'TASK':
//             handleDragEndTask(result);
//             break;
//         default:
//             console.error("NO GROUP FOUNDED");
//             break;
//     }
// }

    return (
        <DragDropContext onDragEnd={handleDragProcess}>
                <ul className="group-preview flex column" style={{  marginBottom: 20}}>
                    <div>
                        <div
                            style={!showGroup ? { height: '76px', width: '100rem', borderLeft: `5px solid ${group.color}`, borderTop: '2px solid #e4e4e4', borderRight: '2px solid #e4e4e4', borderBottom: '2px solid #e4e4e4', borderRadius: 5} : null}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        >
                            <div ref={elMainGroup} style={{ position: 'relative',display: isEditable ? 'block' : 'none' }}>
                                {isHovered && <BiDotsHorizontalRounded onClick={onToggleMenuModal} className="icon" style={{ position: 'absolute', left: -55, bottom: -28, width: '50px',
                                backgroundColor: 'rgba(255, 255, 255, 0.5)'}} size={22} />}
                            </div>


                            <TableContainer className="title-container flex" component={Paper}>
                                <Table style={{ marginTop: -8, borderCollapse: 'collapse' }}>
                                    <TableHead>
                                        <TableRow style={{ height: '10px' }}>
                                            <TableCell style={{ width: '10px', padding: '4px', borderBottom: 'none' }}>
                                                {!showGroup && <BiChevronRight style={{ marginBottom: '-12px' }} size={22} onClick={() => { setShowGroup(!showGroup) }} />}
                                                {showGroup && <BiChevronDown style={{ marginBottom: '-12px' }} size={22} onClick={() => { setShowGroup(!showGroup) }} />}
                                            </TableCell>
                                            <TableCell style={{ width: 500, padding: "4px", borderRight: `1px solid #e4e4e4`, borderBottom: 'none' }}>
                                                <div className={`group-header flex align-center ${!board.description ? 'not-des' : ''}`} style={{ color: group.color }}>
                                                    <div className="group-header-title flex align-center" style={{ alignContent: 'center', alignItems: "center", justifyContent: "center" }}>
                                                        <div ref={elMainGroup} style={{ marginLeft: -8, marginBottom: -12 }} className={`group-title-info flex align-center ${isShowColorPicker ? 'showBorder' : ''}`} onFocus={() => setIsShowColorPicker(true)}>
                                                            {isShowColorPicker && <BsFillCircleFill onClick={onTogglePalette} />}
                                                            <Tooltip title={group.nombre_grupo} arrow>
                                                                <blockquote className="group-title" onFocus={() => setIsTyping(true)} contentEditable onBlur={(ev) => { onSave(ev); setIsTyping(false); }} suppressContentEditableWarning={true}>
                                                                    <h4 style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '480px' }}>{group.nombre_grupo}</h4>
                                                                </blockquote>
                                                            </Tooltip>
                                                            {!isTyping && showGroup && <span className="task-count flex align-center">{getSumOfTasks()}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell style={{ width: 250, padding: '4px', textAlign: 'center', verticalAlign: 'bottom', borderRight: `1px solid #e4e4e4`, borderBottom: 'none' }}>
                                                {!showGroup && 'Tiempo de ejecución.'}
                                            </TableCell>
                                            <TableCell style={{ width: 200, padding: '4px', textAlign: 'center', verticalAlign: 'bottom', borderRight: `1px solid #e4e4e4`, borderBottom: 'none' }}>
                                                {!showGroup && 'Resumen de estados'}
                                            </TableCell>
                                            <TableCell style={{ width: 350, padding: '4px', textAlign: 'center', verticalAlign: 'bottom', borderBottom: 'none' }}>
                                                <p></p>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {!showGroup && (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell style={{ padding: '4px' }}></TableCell>
                                                <TableCell style={{ width: 250, padding: '4px', verticalAlign: 'top', borderRight: `1px solid #e4e4e4`, borderBottom: `1px solid #e4e4e4` }}>{getSumOfTasks()}</TableCell>
                                                <TableCell style={{ width: 250, padding: '4px', textAlign: 'center', verticalAlign: 'top', borderRight: `1px solid #e4e4e4`, borderBottom: `1px solid #e4e4e4` }}>
                                                    <ProgressBar idGrupo={group.fechaMaxMin} barColor={group.color} />
                                                </TableCell>
                                                <TableCell style={{ width: 200, padding: '4px', borderRight: `1px solid #e4e4e4`, borderBottom: `1px solid #e4e4e4` }}>
                                                    <div style={{ marginTop: -8, verticalAlign: 'top', marginLeft: 70 }}><EstadoModal StatusList={group.Estadosactividad} /></div>
                                                </TableCell>
                                                <TableCell style={{  width: 350,padding: '4px', borderBottom: `1px solid #e4e4e4` }}>
                                                    <p></p>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )}
                                </Table>
                            </TableContainer>
                        </div>

                        {showGroup &&
                        <div className="group-preview-content">
                                    <div className={`title-container flex ${!board.description ? ' not-des' : ''}`}>
                                            
                                        {/* Checkbox de cada task */}

                                        {/* <ResizableBox axis="x" width={500} height={40} onResize={onResize}> */}
                                            <div className="sticky-div titles flex" style={{ borderColor: group.color, width:'300%' }}>
                                                <div className="hidden" ></div>
                                                <div className="check-box">
                                                    {/* <input type="checkbox" checked={isMainCheckbox.isActive} onChange={onClickMainCheckbox} /> */}
                                                </div>
                                                <div className="task title" style={{ width: width }}>Elemento</div>
                                            </div>
                                        {/* </ResizableBox> */}

                                        <div className="tasks flex" style={{ borderColor: group.color }}>
                                            <div className="title" style={{ width: "248px" }}>Medio de Verificación</div>
                                        </div>
                                        <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
                                            <div className="title" style={{ width: "10px" }}>Responsable</div>
                                        </div>

                                        <div className="tasks flex" style={{ borderColor: group.color }}>
                                            <div className="title" style={{ width: "10px" }}>Fecha de Inicio</div>
                                        </div>

                                        <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
                                            <div className="title" style={{ width: "10px" }}>Fecha Final</div>
                                        </div>

                                        <div className="tasks flex" style={{ borderColor: group.color }}>
                                            <div className="title" style={{ width: "10px" }}>Meta</div>
                                        </div>
                                        
                                        <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
                                            <div className="title" style={{ width: "10px" }}>Ejecución</div>
                                        </div>

                                        <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
                                            <div className="title" style={{ backgroundColor:"white", width: "10px" }}>Porcentaje</div>
                                        </div>
                                        <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
                                            <div className="title" style={{ width: "171px" }}>Estado</div>
                                        </div>
                                        <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
                                            <div className="title" style={{ width: "169px" }}>Proyecto</div>
                                        </div>

                                        <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
                                            <div className="title" style={{ width: "10px" }}>Archivos</div>
                                        </div>

                                        <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
                                            <div className="title" style={{ width: "380px" }}>Descripción de Avances</div>
                                        </div>

                                        {isEditable && (
                                            <>
                                                <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
                                                    <div className="title" style={{ width:  "250px" }}>Carpeta Drive</div>
                                                </div>
                                                <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
                                                    <div className="title" style={{ width:  "250px" }}>Linea Presupuestaria</div>
                                                </div>
                                                <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
                                                    <div className="title" style={{ width:  "10px" }}>Monto</div>
                                                </div>
                                                <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
                                                    <div className="title" style={{ width:  "180px" }}>Última Modificación</div>
                                                </div>
                                            </>
                                        )}
                                        
                                        <div ref={elAddColumn} className="add-picker-task flex align-items" onClick={toggleColumnModal}>
                                            <span className={`add-btn ${getAddColumnClassName() ? 'active' : ''}`}>
                                                <AiOutlinePlus className={`${getAddColumnClassName() ? 'plus' : 'close'}`} />
                                            </span>
                                        </div>
                                    </div>

                                    <Droppable  isDropDisabled={!isEditable} droppableId={`dndmain-${group.id_grupo}`} type="PARENT">
                                        {(provided) => (
                                            <div ref={provided.innerRef} {...provided.droppableProps}>
                                            {group.actividades
                                            .slice()
                                            .sort((a, b) => a.posicion_elemento - b.posicion_elemento)
                                            .map((task, idx) => (
                                                <Draggable key={task.id_actividad} draggableId={`task-${task.id_actividad}`} index={idx} type="PARENT">
                                                    {(provided) => (
                                                        <li key={task.id_actividad} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                            <TaskPreview key={task.id_actividad} customHeight={customHeight} width={width} width2={width2} users={users} task={task} group={group} board={board} handleCheckboxChange={handleCheckboxChange} isMainCheckbox={isMainCheckbox} />
                                                        </li>
                                                    )}
                                                </Draggable>
                                                ))}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>

                                    {/* Fila para agregar una nueva tarea. */}
                                    <div className="add-task titles flex">
                                        <div className="sticky-div" style={{ borderColor: group.color }}>
                                            <form onSubmit={onAddTask} className="add-task-form flex align-center">
                                                <input type="text"
                                                    name="descripcion"
                                                    value={taskToEdit.descripcion}
                                                    placeholder="+ Agregar elemento"
                                                    onChange={handleChange}
                                                    style={{ width: "500px", cursor: isEditable ? 'pointer' : 'not-allowed' }}
                                                    disabled={!isEditable}
                                                />
                                            </form>
                                        </div>
                                        <div className="empty-div"></div>
                                    </div>

                            {/* Este es el footer de cada tabla */}
                            <div className="statistic flex">
                                <div className="sticky-container" style={{ width: "540px" }}>
                                    <div className="hidden" style={{marginLeft: '-1px'}} ></div>
                                </div>
                                <div className="statistic-container flex" style={{marginLeft:"670px"}}>
                                    
                                    {board.cmpsOrder.map((cmpType, idx) => {
                                        return (
                                            <div key={idx} className={`title ${idx === 0 ? ' first ' : ''}${cmpType}`}>

                                                <StatisticGroup cmpType={cmpType}  board={board} group={group} />
                    
                                            </div>  
                                        )
                                    })}
                                </div>
                                <div className="empty-div"></div>
                            </div>
                        </div>
                    }
                        </div>
                {selectedTasks.length > 0 && <TaskToolsModal board={board} tasks={selectedTasks} group={group} setSelectedTasks={setSelectedTasks} setIsMainCheckbox={setIsMainCheckbox} modalElection = {"GroupPreview"} />}
            </ul>
        </DragDropContext>
    );
}





//VERSION ORIGINAL Y FUNCIONAL


// return <>

// <ul className="group-preview flex column" style={{  marginBottom: 20}}>

//     {/* <Draggable key={group.id_grupo}  draggableId={group.id_grupo + "GRUPO"} index={idx}>
//         {(provided) => {
//             return <div ref={provided.innerRef} {...provided.draggableProps}> */}
//             <div >
                
//                 {/* Este es el nombre del grupo*/}  
//                 {/* <div {...provided.dragHandleProps} className={`group-header flex align-center ${!board.description ? ' not-des' : ''}`} style={{ color: group.color }}> */}    
              


// <div
// style={!showGroup ? { height: '76px', width: '100rem', borderLeft: `5px solid ${group.color}`, borderTop: '2px solid #e4e4e4', borderRight: '2px solid #e4e4e4', borderBottom: '2px solid #e4e4e4', borderRadius: 5 } : null}
// onMouseEnter={() => setIsHovered(true)}
// onMouseLeave={() => setIsHovered(false)}
// >
// <div ref={elMainGroup} style={{ position: 'relative',display: isEditable ? 'block' : 'none' }}>
//     {isHovered && <BiDotsHorizontalRounded onClick={onToggleMenuModal} className="icon" style={{ position: 'absolute', left: -50, bottom: -28, width: '70px',
//     backgroundColor: 'rgba(255, 255, 255, 0.5)'}} size={22} />}
// </div>


// <TableContainer className="title-container flex" component={Paper}>
//     <Table style={{ marginTop: -8, borderCollapse: 'collapse' }}>
//         <TableHead>
//             <TableRow style={{ height: '10px' }}>
//                 <TableCell style={{ width: '10px', padding: '4px', borderBottom: 'none' }}>
//                     {!showGroup && <BiChevronRight style={{ marginBottom: '-12px' }} size={22} onClick={() => { setShowGroup(!showGroup) }} />}
//                     {showGroup && <BiChevronDown style={{ marginBottom: '-12px' }} size={22} onClick={() => { setShowGroup(!showGroup) }} />}
//                 </TableCell>
//                 <TableCell style={{ width: 500, padding: "4px", borderRight: `1px solid #e4e4e4`, borderBottom: 'none' }}>
//                     <div className={`group-header flex align-center ${!board.description ? 'not-des' : ''}`} style={{ color: group.color }}>
//                         <div className="group-header-title flex align-center" style={{ alignContent: 'center', alignItems: "center", justifyContent: "center" }}>
//                             <div ref={elMainGroup} style={{ marginLeft: -8, marginBottom: -12 }} className={`group-title-info flex align-center ${isShowColorPicker ? 'showBorder' : ''}`} onFocus={() => setIsShowColorPicker(true)}>
//                                 {isShowColorPicker && <BsFillCircleFill onClick={onTogglePalette} />}
//                                 <Tooltip title={group.nombre_grupo} arrow>
//                                     <blockquote className="group-title" onFocus={() => setIsTyping(true)} contentEditable onBlur={(ev) => { onSave(ev); setIsTyping(false); }} suppressContentEditableWarning={true}>
//                                         <h4 style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '480px' }}>{group.nombre_grupo}</h4>
//                                     </blockquote>
//                                 </Tooltip>
//                                 {!isTyping && showGroup && <span className="task-count flex align-center">{getSumOfTasks()}</span>}
//                             </div>
//                         </div>
//                     </div>
//                 </TableCell>
//                 <TableCell style={{ width: 250, padding: '4px', textAlign: 'center', verticalAlign: 'bottom', borderRight: `1px solid #e4e4e4`, borderBottom: 'none' }}>
//                     {!showGroup && 'Tiempo de ejecución.'}
//                 </TableCell>
//                 <TableCell style={{ width: 200, padding: '4px', textAlign: 'center', verticalAlign: 'bottom', borderRight: `1px solid #e4e4e4`, borderBottom: 'none' }}>
//                     {!showGroup && 'Resumen de estados'}
//                 </TableCell>
//                 <TableCell style={{ width: 350, padding: '4px', textAlign: 'center', verticalAlign: 'bottom', borderBottom: 'none' }}>
//                     <p></p>
//                 </TableCell>
//             </TableRow>
//         </TableHead>
//         {!showGroup && (
//             <TableBody>
//                 <TableRow>
//                     <TableCell style={{ padding: '4px' }}></TableCell>
//                     <TableCell style={{ width: 250, padding: '4px', verticalAlign: 'top', borderRight: `1px solid #e4e4e4`, borderBottom: `1px solid #e4e4e4` }}>{getSumOfTasks()}</TableCell>
//                     <TableCell style={{ width: 250, padding: '4px', textAlign: 'center', verticalAlign: 'top', borderRight: `1px solid #e4e4e4`, borderBottom: `1px solid #e4e4e4` }}>
//                         <ProgressBar idGrupo={group.fechaMaxMin} barColor={group.color} />
//                     </TableCell>
//                     <TableCell style={{ width: 200, padding: '4px', borderRight: `1px solid #e4e4e4`, borderBottom: `1px solid #e4e4e4` }}>
//                         <div style={{ marginTop: -8, verticalAlign: 'top', marginLeft: 70 }}><EstadoModal StatusList={group.Estadosactividad} /></div>
//                     </TableCell>
//                     <TableCell style={{  width: 350,padding: '4px', borderBottom: `1px solid #e4e4e4` }}>
//                         <p></p>
//                     </TableCell>
//                 </TableRow>
//             </TableBody>
//         )}
//     </Table>
// </TableContainer>
// </div>

                

                
               
        
//                 {showGroup &&
//                 <div className="group-preview-content">
//                     {/* Este es el header de cada tabla */}
//                     {/* <DragDropContext onDragEnd={handleHorizontalDrag}>
//                         <Droppable droppableId="title" direction="horizontal">
//                             {(droppableProvided) => {
//                                 return <div ref={droppableProvided.innerRef} {...droppableProvided.droppableProps} className={`title-container flex ${!board.description ? ' not-des' : ''}`}> */}
//                                 <div className={`title-container flex ${!board.description ? ' not-des' : ''}`}>
                                    
//                                     {/* Checkbox de cada task */}

//                                     {/* <ResizableBox axis="x" width={500} height={40} onResize={onResize}> */}
//                                         <div className="sticky-div titles flex" style={{ borderColor: group.color, width:'300%' }}>
//                                             <div className="hidden" ></div>
//                                             <div className="check-box">
//                                                 {/* <input type="checkbox" checked={isMainCheckbox.isActive} onChange={onClickMainCheckbox} /> */}
//                                             </div>
//                                             <div className="task title" style={{ width: width }}>Elemento</div>
//                                         </div>
//                                     {/* </ResizableBox> */}

//                                     <div className="tasks flex" style={{ borderColor: group.color }}>
//                                         <div className="title" style={{ width: "248px" }}>Medio de Verificación</div>
//                                     </div>
//                                     <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
//                                         <div className="title" style={{ width: "10px" }}>Responsable</div>
//                                     </div>

//                                     <div className="tasks flex" style={{ borderColor: group.color }}>
//                                         <div className="title" style={{ width: "10px" }}>Fecha de Inicio</div>
//                                     </div>

//                                     <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
//                                         <div className="title" style={{ width: "10px" }}>Fecha Final</div>
//                                     </div>

//                                     <div className="tasks flex" style={{ borderColor: group.color }}>
//                                         <div className="title" style={{ width: "10px" }}>Meta</div>
//                                     </div>
                                   
//                                     <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
//                                         <div className="title" style={{ width: "10px" }}>Ejecución</div>
//                                     </div>

//                                     <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
//                                         <div className="title" style={{ backgroundColor:"white", width: "10px" }}>Porcentaje</div>
//                                     </div>
//                                     <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
//                                         <div className="title" style={{ width: "171px" }}>Estado</div>
//                                     </div>
//                                     <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
//                                         <div className="title" style={{ width: "169px" }}>Proyecto</div>
//                                     </div>

//                                     <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
//                                         <div className="title" style={{ width: "10px" }}>Archivos</div>
//                                     </div>

//                                     <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
//                                         <div className="title" style={{ width: "380px" }}>Descripción de Avances</div>
//                                     </div>
//                                     {isEditable && (
//                                     <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
//                                         <div className="title" style={{ width:  "250px" }}>Carpeta Drive</div>
//                                     </div>
//                                      )}

//                                      {isEditable && (
//                                     <div className="tasks flex" style={{backgroundColor:"white", borderColor: group.color }}>
//                                         <div className="title" style={{ width:  "180px" }}>Última Modificación</div>
//                                     </div>
//                                     )}
                                

//                                     <div ref={elAddColumn} className="add-picker-task flex align-items" onClick={toggleColumnModal}>
//                                         <span className={`add-btn ${getAddColumnClassName() ? 'active' : ''}`}>
//                                             <AiOutlinePlus className={`${getAddColumnClassName() ? 'plus' : 'close'}`} />
//                                         </span>
//                                     </div>
//                                 </div>
//                             {/* }}
//                         </Droppable>
//                     </DragDropContext> */}



//                     {/* Aqui van los items o tasks */}
//                     {/* <Droppable droppableId={"a_" + group.id_grupo} type='task'>
//                         {(droppableProvided) => ( */}
//                             {/* <div ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}> */}
//                             <div>
//                                 {group.actividades.map( (task, idx) => (
//                                     // <Draggable key={"tsxid_" + task.id_actividad} draggableId={"tsx_" + task.id_actividad} index={idx}>
//                                     //     {(provided) => (
//                                             // <li ref={provided.innerRef}{...provided.draggableProps} {...provided.dragHandleProps} key={idx}>
//                                             <li key={task.id_actividad}>
//                                                 <TaskPreview key={task.id_actividad} customHeight={customHeight} width={width} width2={width2} users={users} task={task} group={group} board={board} handleCheckboxChange={handleCheckboxChange} isMainCheckbox={isMainCheckbox} />
//                                             </li>
//                                     //     )}
                                        
//                                     // </Draggable>
//                                 ))}
//                                 {/* {droppableProvided.placeholder} */}

//                                 {/* Fila para agregar una nueva tarea. */}
//                                 <div className="add-task titles flex">
//                                     <div className="sticky-div" style={{ borderColor: group.color }}>

//                                         <form onSubmit={onAddTask} className="add-task-form flex align-center">
//                                             <input type="text"
//                                                 name="descripcion"
//                                                 value={taskToEdit.descripcion}
//                                                 placeholder="+ Agregar elemento"
//                                                 onChange={handleChange}
//                                                 style={{ width: "500px", cursor: isEditable ? 'pointer' : 'not-allowed' }}
//                                                 disabled={!isEditable}
//                                             />

//                                             {/* <input type="text"
//                                                 name="estado"
//                                                 value={taskToEdit.fk_estado_id}
//                                                 placeholder="+ Estado"
//                                                 onChange={handleChange}
//                                                 style={{ width: "100px" }}
//                                             />


//                                             <input type="text"
//                                                 name="meta"
//                                                 value={taskToEdit.meta}
//                                                 placeholder="+ Agregar meta"
//                                                 onChange={handleChange}
//                                                 style={{ width: "100px" }}
//                                             />
//                                             <input type="text"
//                                                 name="ejecucion"
//                                                 value={taskToEdit.ejecucion}
//                                                 placeholder="+ Agregar ejecución"
//                                                 onChange={handleChange}
//                                                 style={{ width: "100px" }}
//                                             />
//                                             <input type="text"
//                                                 name="medio_verificacion"
//                                                 value={taskToEdit.medio_verificacion}
//                                                 placeholder="+ Agregar medio de verificación"
//                                                 onChange={handleChange}
//                                                 style={{ width: "200px" }}
//                                             />
//                                             <input type="text"
//                                                 name="avances"
//                                                 value={taskToEdit.avances}
//                                                 placeholder="+ Agregar avances"
//                                                 onChange={handleChange}
//                                                 style={{ width: "100px" }}
//                                             />
//                                             <input type="date"
//                                                 name="fecha_inicio"
//                                                 value={taskToEdit.fecha_inicio}
//                                                 onChange={handleChange}
//                                                 style={{ width: "150px" }}
//                                             />
//                                             <input type="date"
//                                                 name="fecha_final"
//                                                 value={taskToEdit.fecha_final}
//                                                 onChange={handleChange}
//                                                 style={{ width: "150px" }}
//                                             />

//                                             <input type="date"
//                                                 name="fecha_final"
//                                                 value={taskToEdit.fecha_final}
//                                                 onChange={handleChange}
//                                                 style={{ width: "150px" }}
//                                             />

//                                             <input type="date"
//                                                 name="fecha_final"
//                                                 value={taskToEdit.fecha_final}
//                                                 onChange={handleChange}
//                                                 style={{ width: "150px" }}
//                                             /> */}
    
//                                             {/* <button type="submit">Guardar</button> */}
                                            
//                                         </form>
                                        

                                        
                                        
//                                     </div>
//                                     <div className="empty-div"></div>
//                                 </div>
//                             </div>
//                          {/* )}
//                      </Droppable> */}




//                     {/* Este es el footer de cada tabla */}
//                     <div className="statistic flex">
//                         <div className="sticky-container" style={{ width: "540px" }}>
//                             <div className="hidden" style={{marginLeft: '-1px'}} ></div>
//                         </div>
//                         <div className="statistic-container flex" style={{marginLeft:"670px"}}>
                            
//                             {board.cmpsOrder.map((cmpType, idx) => {
//                                 return (
//                                     <div key={idx} className={`title ${idx === 0 ? ' first ' : ''}${cmpType}`}>

//                                         <StatisticGroup cmpType={cmpType}  board={board} group={group} />
            
//                                     </div>

                
                                    
//                                 )
//                             })}
//                         </div>
//                         <div className="empty-div"></div>
//                     </div>
//                 </div>
//         }
//             </div>
//         {/* }}
//     </Draggable> */}
//     {selectedTasks.length > 0 && <TaskToolsModal board={board} tasks={selectedTasks} group={group} setSelectedTasks={setSelectedTasks} setIsMainCheckbox={setIsMainCheckbox} modalElection = {"GroupPreview"} />}
// </ul>
// </>
// }



